// TODO: mutate함수 이름 use~로 지은 거 모두 수정하기. 해당 파일이 주요한 로직이고, 수정할 함수가 너무 많아서 수정 못했음.
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
  Dispatch,
  SetStateAction,
} from 'react';
import { useMutation, useLazyQuery } from '@apollo/client';
import { shallowEqual } from 'react-redux';
import * as Sentry from '@sentry/nextjs';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { RootState } from '@store/store';
import { AutoPlayType, UserSelectedChoice } from '@customTypes/chapter';
import {
  BadgesAcquired,
  ReachedEnding,
  StoryItem,
  EndingCard,
} from '@customTypes/story';
import { convertCharName, getChatGptURL } from '@common/utils';
import { STORAGE_KEY } from '@common/values';
import {
  getChoiceSaveProps,
  handleCondition,
  handleFinalEndings,
  isShowStatement,
  onLoadStory,
  onSavePlayData,
  onMergeProps,
  setCustomNameToText,
  getUserInputChoiceItem,
  getChoiceRateItem,
  getMakeChoiceInfo,
  getUpdatedItems,
  onExecuteCondition,
  setStatementCustomText,
  chatCalculate,
  mergeChoiceToProps,
  convertPropsCountFormat,
  onReplacePostPosition,
} from '@service/ChapterService';
import { setIsLoading } from '@/slices/chatChapterSlice';
import {
  endChapterFirst,
  endStoryAll,
  endChapter,
  endStory,
  startAutoPlayReading,
  makeChoice,
  viewChapterEnding,
  viewChapterEndingFirst,
} from '@lib/eventManager';
import {
  ChatAudio,
  ChatBlock,
  ChoiceResult,
  MakeChoiceData,
  Statement,
  StatementItem,
  TextOptions,
  TTSCashingData,
  TopToast,
  IFullWidthImageFullScreenOption,
} from '@/customTypes/chatStory';
import {
  MAKE_CHOICE,
  REACHED_ENDING,
  SEND_ACHIEVEMENT_EVENT,
  UPDATE_USER_ITEM,
  UPDATE_USER_PROPS,
  GET_USER_CHOICE_RESULT,
  GET_USER_INPUT_CHOICE,
  REQUESTS_TTS,
  GET_TTS_URL,
  SYNC_USER_ITEMS,
} from '@api/story';
import { GET_USER_ONBOARDING_STORY } from '@api/user';
import { UserOnboardingStory } from '@customTypes/user';
import { GET_REMOTE_SCRIPT_STATEMENTS, GET_CURRENT_PROPS } from '@api/chapter';

import { useChatPlayDataContext } from './ChatPlayDataProvider';

const FLOATING_COUNT = 100;

interface IChatPlay {
  chatList: StatementItem[];
  choice?: Statement;
  background?: ImageFile; // 화면에 표시되는 배경 이미지 정보
  toastList: Statement[];
  badgesAcquired?: BadgesAcquired[]; // 팝업에 표시될 badge정보
  storyItems?: StoryItem[]; // 팝업에 표시될 Item
  autoPlayType: AutoPlayType;
  endingPopupInfo?: ReachedEnding & {
    isShow: boolean;
  };
  chatBlockRef?: React.MutableRefObject<ChatBlock | undefined>; // 현재 플레이중인 블럭
  scrollRef?: React.RefObject<HTMLDivElement>;
  fastRateRef?: React.MutableRefObject<number>;
  choiceStatistics?: {
    choiceResult: ChoiceResult;
    selectedIndex: number;
    isReplay: boolean;
  };
  characterProfile?: {
    title: string;
    imageUrl?: string;
  };
  topToasts?: TopToast[];
  chatSoundEffect?: ChatAudio;
  chatBGM?: ChatAudio;
  chatTTS?: ChatAudio;
  isTTSOnRef?: React.MutableRefObject<boolean | undefined>;
  isShowFloatingAD: boolean;
  isShowRetryChatGPTPopup: boolean;
  currentStatement?: StatementItem;
  onChatGPTMode: boolean;
  // action
  setAutoPlayType: Dispatch<SetStateAction<AutoPlayType>>;
  getProfile: (statement: Statement) => string | undefined;
  onFinishAutoPlay: () => void;
  onChatProgress: (pressType?: 'click' | 'item' | 'achievement') => void;
  onChoice: ({
    choiceName,
    choiceItem,
    choiceUserInput,
  }: {
    choiceName: string;
    choiceItem?: {
      choiceIndex: number;
      selectedName: string;
    };
    choiceUserInput?: {
      leftUserInputText?: string;
      rightUserInputText?: string;
    };
  }) => void;
  onSavePlay: () => void;
  setToastList: Dispatch<SetStateAction<Statement[] | []>>;
  onAutoPlayRate: (rate: number) => void;
  onConfirmPopup: (type: 'item' | 'achievement' | 'ending') => void;
  resetEnding: () => void;
  initChatData: () => Promise<unknown>;
  oncloseChoiceStatistics: () => void;
  onGetChoiceResult: (info: {
    storyId: number;
    chapterId: number;
    choiceId: number;
  }) => void;
  onShowCharacterProfile: (characterProfile?: {
    title: string;
    imageUrl?: string;
  }) => void;
  onPlayTTSStatement: (statement: Statement) => void;
  setTopToasts: Dispatch<SetStateAction<TopToast[] | undefined>>;
  onCloseFloatingAD: () => void;
  onRemoteScriptChatGPT: (statement: Statement) => void;
  setIsShowRetryChatGPTPopup: Dispatch<SetStateAction<boolean>>;
  fullScreenEffectInfo: StatementItem | null;
  fullScreenImagePopupInfo: IFullWidthImageFullScreenOption | null;
  setFullScreenImagePopupInfo: Dispatch<
    SetStateAction<IFullWidthImageFullScreenOption | null>
  >;
}

const initialState: IChatPlay = {
  chatList: [],
  choice: undefined,
  background: undefined,
  toastList: [],
  badgesAcquired: undefined,
  storyItems: undefined,
  autoPlayType: 'hidden',
  endingPopupInfo: undefined,
  chatBlockRef: undefined,
  scrollRef: undefined,
  fastRateRef: undefined,
  choiceStatistics: undefined,
  characterProfile: undefined,
  topToasts: undefined,
  chatSoundEffect: undefined,
  chatBGM: undefined,
  chatTTS: undefined,
  isTTSOnRef: undefined,
  isShowFloatingAD: false,
  isShowRetryChatGPTPopup: false,
  currentStatement: undefined,
  onChatGPTMode: false,
  setAutoPlayType: () => {},
  getProfile: (statement: Statement) => '',
  onFinishAutoPlay: () => {},
  onChatProgress: (pressType?: 'click' | 'item' | 'achievement') => {},
  onChoice: ({
    choiceName,
    choiceItem,
    choiceUserInput,
  }: {
    choiceName: string;
    choiceItem?: {
      choiceIndex: number;
      selectedName: string;
    };
    choiceUserInput?: {
      leftUserInputText?: string;
      rightUserInputText?: string;
    };
  }) => {},
  onSavePlay: () => {},
  setToastList: () => {},
  onAutoPlayRate: (rate: number) => {},
  onConfirmPopup: (type: 'item' | 'achievement' | 'ending') => {},
  resetEnding: () => {},
  initChatData: () => {
    return new Promise((resolve, reject) => {});
  },
  oncloseChoiceStatistics: () => {},
  onGetChoiceResult: (info: {
    storyId: number;
    chapterId: number;
    choiceId: number;
  }) => {},
  onShowCharacterProfile: (characterProfile?: {
    title: string;
    imageUrl?: string;
  }) => {},
  onPlayTTSStatement: (statement: Statement) => {},
  setTopToasts: () => {},
  onCloseFloatingAD: () => {},
  setIsShowRetryChatGPTPopup: () => {},
  onRemoteScriptChatGPT: (statement: Statement) => {},
  fullScreenEffectInfo: null,
  fullScreenImagePopupInfo: null,
  setFullScreenImagePopupInfo: () => {},
};

const ChatStoryContext = createContext<IChatPlay | undefined>(initialState);

const ChatPlayProvider = ({
  children,
}: {
  children: JSX.Element | Array<JSX.Element>;
}) => {
  const { playChapterInfo } = useAppSelector(
    (state: RootState) => state.chapter,
    shallowEqual,
  );
  const { isRestarting } = useAppSelector(
    (state: RootState) => state.chapter,
    shallowEqual,
  );
  const dispatchRTK = useAppDispatch();
  const {
    propsRef,
    itemsRef,
    chatProgressRef,
    updateProps,
    updateItems,
    setChatProgress,
    setBlockHistory,
    getPlayDataString,
    updateAchievements,
  } = useChatPlayDataContext();

  const [chatList, setChatList] = useState<StatementItem[]>([]); // 화면에 표시되는 채팅목록
  const [choice, setChoice] = useState<Statement>(); // Choice 선택 정보, choice에 정보가 있다면 선택 대기 모드
  const [background, setBackground] = useState<ImageFile>(); // 화면에 표시되는 배경 이미지 정보
  const [toastList, setToastList] = useState<Statement[]>([]); // Toast 메시지 리스트 화면에 표시
  const [badgesAcquired, setBadgesAcquired] = useState<BadgesAcquired[]>(); // 팝업에 표시될 badge정보
  const [storyItems, setStoryItems] = useState<StoryItem[]>(); // 팝업에 표시될 Item
  const [autoPlayType, setAutoPlayType] = useState<AutoPlayType>('hidden');
  const [endingPopupInfo, setEndingPopupInfo] = useState<
    ReachedEnding & { isShow: boolean }
  >();
  const [choiceStatistics, setChoiceStatistics] = useState<{
    choiceResult: ChoiceResult;
    selectedIndex: number;
    isReplay: boolean;
  }>();
  const [chatLoading, setChatLoading] = useState<boolean>(false);
  const [characterProfile, setCharacterProfile] = useState<{
    title: string;
    imageUrl?: string;
  }>();
  const [chatSoundEffect, setChatSoundEffect] = useState<ChatAudio>();
  const [chatBGM, setChatSoundBGM] = useState<ChatAudio>();
  const [chatTTS, setChatSoundTTS] = useState<ChatAudio>();
  const [topToasts, setTopToasts] = useState<TopToast[] | undefined>([]); // Toast 메시지 화면에 표시
  const [isShowFloatingAD, setIsShowFloatingAD] = useState<boolean>(false);
  const [onChatGPTMode, setOnChatGPTMode] = useState<boolean>(false);
  const [currentStatement, setCurrentStatement] = useState<StatementItem>();
  const [isShowRetryChatGPTPopup, setIsShowRetryChatGPTPopup] =
    useState<boolean>(false);
  const [remoteChatGPTStatement, setRemoteChatGPTStatement] =
    useState<Statement[]>();
  const [fullScreenEffectInfo, setFullScreenEffectInfo] =
    useState<StatementItem | null>(null);
  const [fullScreenImagePopupInfo, setFullScreenImagePopupInfo] =
    useState<IFullWidthImageFullScreenOption | null>(null);
  const [isPause, setIsPause] = useState(false);
  const [autoPlayMode, setAutoPlayMode] = useState<boolean>(false);

  const retryCountRef = useRef(1);
  const remoteStatementsRef = useRef<Statement[]>();
  const chatBlockRef = useRef<ChatBlock>(); // 플레이중인 block정보
  const autoPlayRef = useRef<NodeJS.Timeout>(); // 자동 스토리 진행 thread ref
  const fastRateRef = useRef<number>(1.0); // 자동재생 속도
  const scrollRef = useRef<HTMLDivElement>(null);
  const choiceRef = useRef<{
    choiceName: string;
    choiceIndex: number;
    choiceUserInput?: {
      leftUserInputText?: string;
      rightUserInputText?: string;
    };
  }>({
    choiceName: '',
    choiceIndex: 0,
    choiceUserInput: undefined,
  });
  const cashingTTSListRef = useRef<TTSCashingData[]>([]);
  const cashingTTSRef = useRef<TTSCashingData>();
  const isTTSOnRef = useRef<boolean>();
  const itemOPCountRef = useRef<number>();
  const choiceOptionsRef = useRef<Statement[]>([]);
  const choiceToInfoRef = useRef<Record<string, number | string>>();
  const floatingADCountRef = useRef<number>(0);

  const [useSendAchievementEvent, { loading: achievementLoading }] =
    useMutation(SEND_ACHIEVEMENT_EVENT, {
      onCompleted: (res) => {
        const achievementBadge: BadgesAcquired[] =
          res?.sendAchievementEvent?.badgesAcquired;
        if (achievementBadge && achievementBadge.length > 0) {
          updateAchievements(achievementBadge);
          setBadgesAcquired(achievementBadge);
        } else {
          // badge가 비어있다면 이미 획득한 성과
          onChatProgress();
        }
      },
      onError: (error) => {
        onChatProgress();
      },
      fetchPolicy: 'no-cache',
    }); // 업적달성

  // 선택 정보 서버 전달
  const [useMakeChoice, { loading: choiceLoading }] = useMutation<{
    makeChoice: {
      ok: number;
      storyItems?: StoryItem[];
      achievement?: {
        badgesAcquired?: BadgesAcquired[];
      };
      choiceResult?: ChoiceResult;
      userSelectedChoice?: UserSelectedChoice;
    };
  }>(MAKE_CHOICE, {
    onCompleted: (choiceResult) => {
      if (choiceResult?.makeChoice?.ok === 1) {
        choiceRef.current.choiceUserInput && addChoiceInputItem();
        const achievementBadge: BadgesAcquired[] =
          choiceResult.makeChoice?.achievement?.badgesAcquired || [];
        let isPlay = true;
        if (
          choiceResult.makeChoice?.storyItems &&
          choiceResult.makeChoice?.storyItems?.length > 0
        ) {
          let userItems: StoryItem[] =
            choiceResult.makeChoice.storyItems.filter((item) => !item.isHidden);
          if (userItems.length > 0) {
            userItems = userItems.map((item) => {
              const itemValue = choiceToInfoRef.current?.[item.name];
              return {
                ...item,
                itemCount:
                  typeof itemValue === 'number'
                    ? Number(itemsRef.current![item.name])
                    : undefined,
              };
            });

            const popupItems = userItems.filter(
              (item) => (item.itemCount || 0) >= 0,
            );
            popupItems.length > 0 && setStoryItems(popupItems);

            userItems
              .filter((item) => (item.itemCount || 0) < 0)
              .forEach((item) => {
                onUpdateItemToast(item);
              });
          }

          if (choiceToInfoRef.current) {
            if (choiceToInfoRef.current) {
              choiceToInfoRef.current = undefined;
            }
          }
          isPlay = false;
        }
        if (choiceResult?.makeChoice?.choiceResult) {
          handleChoiceStatistics({
            choiceResult: choiceResult?.makeChoice?.choiceResult,
            selectedIndex:
              choiceResult?.makeChoice?.userSelectedChoice?.selectedChoice ||
              choiceRef.current.choiceIndex,
            isReplay: false,
          });
          isPlay = false;
        }
        if (achievementBadge && achievementBadge.length > 0) {
          updateAchievements(achievementBadge);
          setBadgesAcquired(achievementBadge);
          isPlay = false;
        }

        const statements = chatBlockRef.current?.statements;
        const nextStatement = statements?.[chatProgressRef.current.index];
        (nextStatement?.statementType === 'ChoiceToBlock' || isPlay) &&
          onChoiceResult();
      }
      choiceOptionsRef.current = [];
    },
    onError: (choiceError) => {
      if (choiceToInfoRef.current) {
        if (choiceToInfoRef.current) {
          choiceToInfoRef.current = undefined;
        }
      }
      choiceOptionsRef.current = [];
      setAutoPlayType('hidden');
    },
    fetchPolicy: 'no-cache',
  });

  const [getUserOnboardingStory] = useLazyQuery<UserOnboardingStory>(
    GET_USER_ONBOARDING_STORY,
    {
      onCompleted: (data) => {
        if (data) {
          const fistStartStoryId = Number(
            data?.getUserMetric?.onBoardingStory?.storyId,
          );
          const currentStoryId = Number(playChapterInfo?.playChapter?.storyId);
          const isOnboardingStory = currentStoryId === fistStartStoryId;

          isOnboardingStory &&
            playChapterInfo &&
            endChapterFirst({
              storyName: playChapterInfo.playChapter.story.name,
              storyId: playChapterInfo.playChapter.storyId,
              chapterId: playChapterInfo.playChapter.chapterId,
              chapterIndex: playChapterInfo.playChapter.chapterIndex,
              storyType: 'home',
              contentType: 'interactive',
            });
          isOnboardingStory &&
            viewChapterEndingFirst({
              storyName: playChapterInfo?.playChapter?.story.name,
              storyId: String(playChapterInfo?.playChapter?.storyId),
              chapterId: playChapterInfo?.playChapter?.chapterId,
              chapterIndex: playChapterInfo?.playChapter.chapterIndex,
              storyType: 'home',
              contentType: 'interactive',
            });
        }
      },
      fetchPolicy: 'network-only',
    },
  );

  const callEndChapterEvent = ({
    reachedEnding,
    endingCard,
  }: {
    reachedEnding: ReachedEnding;
    endingCard?: EndingCard;
  }) => {
    endStoryAll();
    endChapter({
      storyName: playChapterInfo?.playChapter?.story.name,
      chapterIndex: playChapterInfo?.playChapter?.chapterIndex,
      endingId: reachedEnding.ending.endingId,
      endingTitle: reachedEnding.ending.name,
      storyId: playChapterInfo?.playChapter?.storyId,
      chapterId: playChapterInfo?.playChapter?.chapterId,
      storyType: playChapterInfo?.playChapter?.story.isMWS
        ? 'challenge'
        : 'home',
      contentType: 'interactive',
      withCustomCharacter:
        playChapterInfo?.playChapter?.story.lastPlay?.currentPlayingChapter
          .withAICustomCharacter === true,
    });
    viewChapterEnding({
      storyName: playChapterInfo?.playChapter.story.name,
      storyId: String(playChapterInfo?.playChapter.storyId),
      chapterId: String(playChapterInfo?.playChapter.chapterId),
      chapterIndex: playChapterInfo?.playChapter.chapterIndex,
      endingId: reachedEnding.ending.endingId,
      endingTitle: reachedEnding.ending.name,
      storyType: 'home',
      contentType: 'interactive',
    });
    reachedEnding.ending.isFinal &&
      endStory({
        storyName: playChapterInfo?.playChapter?.story.name,
        endingSummary: reachedEnding.ending.collectionDescription,
        endingTitle: reachedEnding.ending.name,
        storyId: playChapterInfo?.playChapter.storyId,
        endingId: reachedEnding.ending.endingId,
        rareEnding: reachedEnding.ending.arrivalRate || undefined,
        choiceCount: endingCard?.choiceCount,
        collectionRate: endingCard?.endingCollectRate,
        screenName: 'chat',
      });
    playChapterInfo?.playChapter.chapterIndex === 1 &&
      !isRestarting &&
      getUserOnboardingStory();
  };

  // 엔딩 결과 서버 전달
  const [
    useReachedEnding,
    { loading: reachedEndingLoading, reset: resetEnding },
  ] = useMutation(REACHED_ENDING, {
    onCompleted: (reachedEndingRes) => {
      if (reachedEndingRes) {
        const reachedEnding: ReachedEnding = reachedEndingRes?.reachedEnding;
        const endingCard = reachedEnding.ending.additionalCards?.find(
          (item) => {
            item.endingId === reachedEnding.ending.endingId;
          },
        );

        callEndChapterEvent({ reachedEnding, endingCard });
        setEndingPopupInfo({ ...reachedEnding, isShow: true });
        moveToEnd(500);
      } else {
        setEndingPopupInfo(undefined);
      }
    },
    onError: (error) => {},
    fetchPolicy: 'no-cache',
  });

  // 아이템 획득
  const [useUpdateItem, { loading: userItemLoading }] = useMutation<{
    updateUserItems: StoryItem;
  }>(UPDATE_USER_ITEM, {
    onCompleted: (userItemRes) => {
      if (userItemRes) {
        const userItem: StoryItem = userItemRes.updateUserItems;
        if (!userItem.isHidden) {
          if ((itemOPCountRef.current || 0) >= 0) {
            setStoryItems([
              {
                ...userItem,
                itemCount: itemOPCountRef.current,
              },
            ]);
          } else {
            onUpdateItemToast({
              ...userItem,
              itemCount: itemOPCountRef.current,
            });
          }
          itemOPCountRef.current = undefined;
        }
        onChatProgress();
      }
    },
    onError: (error) => {},
    fetchPolicy: 'no-cache',
  });

  const [onUserProps, { loading: propsLoading }] = useMutation(
    UPDATE_USER_PROPS,
    {
      onCompleted: (propsResult) => {},
      onError: (error) => {},
      fetchPolicy: 'no-cache',
    },
  );

  const [useGetCurrentProps] = useLazyQuery<{
    getStoryV3: {
      lastPlay: {
        currentPlayingChapter: {
          currentProps: string;
        };
      };
    };
  }>(GET_CURRENT_PROPS, {
    onCompleted: (res) => {
      const currentProps =
        res?.getStoryV3.lastPlay.currentPlayingChapter.currentProps;
      const parsedProps = JSON.parse(currentProps);
      updateProps(parsedProps);
    },
  });

  const [
    getChoiceResultMutation,
    { data: getChoiceResult, loading: choiceResultLoading },
  ] = useLazyQuery<{
    getUserChoiceResult: {
      choiceResult?: ChoiceResult;
      userSelectedChoice?: UserSelectedChoice;
    };
  }>(GET_USER_CHOICE_RESULT, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (getChoiceResult) {
      const getUserChoiceResult = getChoiceResult?.getUserChoiceResult;
      if (getUserChoiceResult?.choiceResult) {
        handleChoiceStatistics({
          choiceResult: getUserChoiceResult?.choiceResult,
          selectedIndex:
            getUserChoiceResult?.userSelectedChoice?.selectedChoice ?? 1,
          isReplay: true,
        });
      }
    }
  }, [getChoiceResult]);

  const [useGetUserInputChoice, { loading: userInputChoiceLoading }] =
    useLazyQuery<{ getUserInputChoice: { choiceIndex: number } }>(
      GET_USER_INPUT_CHOICE,
      {
        onCompleted: (res) => {
          const userInputChoice = res.getUserInputChoice;
          choiceRef.current.choiceIndex = userInputChoice.choiceIndex;
          const choiceInfo: MakeChoiceData = {
            storyId: playChapterInfo?.playChapter.storyId ?? 0,
            chapterId: playChapterInfo?.playChapter.chapterId ?? 0,
            choiceName: choiceRef.current.choiceName,
            choice: userInputChoice.choiceIndex + 1,
            showStatistics: choice?.options?.showStatistics ?? false,
            leftUserInputText:
              choiceRef.current?.choiceUserInput?.leftUserInputText,
            rightUserInputText:
              choiceRef.current?.choiceUserInput?.rightUserInputText,
            updatedUserProps: JSON.stringify(propsRef.current),
          };
          onMakeChoice({ choiceInfo, isClearChoice: false });
        },
        onError: (error) => {
          setAutoPlayType('hidden');
        },
        fetchPolicy: 'no-cache',
      },
    );

  const [useRequestsTTS, { loading: requestsTTSLoading }] = useMutation<{
    requestTts: { accessToken: string };
  }>(REQUESTS_TTS, {
    onCompleted: (res) => {
      if (cashingTTSRef.current) {
        cashingTTSListRef.current.push({
          ...cashingTTSRef.current,
          accessToken: res.requestTts.accessToken,
        });
        cashingTTSRef.current = undefined;
      }
      onChatProgress();
    },
    onError: (error) => {},
    fetchPolicy: 'no-cache',
  });

  const [useGetTTSUrl, { loading: getTTSUrlLoading }] = useMutation<{
    getTtsUrl: { url: string };
  }>(GET_TTS_URL, {
    onCompleted: (res) => {
      setChatSoundTTS({
        audioLink: res.getTtsUrl.url,
        type: 'TTS',
      });
    },
    onError: (error) => {},
    fetchPolicy: 'no-cache',
  });

  const [useSyncUserItem, { loading: syncUserItemLoading }] = useMutation<{
    ok: number;
  }>(
    SYNC_USER_ITEMS,
    //    {
    //   onCompleted: (res) => {
    //     // error 처리 시나리오 확정 후 코드 추가
    //   },
    //   onError: (error) => {
    //     // error 처리 시나리오 확정 후 코드 추가
    //   },
    // }
  );

  const [
    useGetRemoteScript,
    { data: remoteScriptData, loading: remoteScriptLoading },
  ] = useLazyQuery<{
    getRemoteScriptStatements: {
      statements: string;
    };
  }>(GET_REMOTE_SCRIPT_STATEMENTS, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    const isLoading =
      userItemLoading ||
      choiceLoading ||
      achievementLoading ||
      choiceResultLoading ||
      reachedEndingLoading ||
      propsLoading ||
      chatLoading ||
      userInputChoiceLoading ||
      requestsTTSLoading ||
      getTTSUrlLoading ||
      syncUserItemLoading ||
      remoteScriptLoading;
    dispatchRTK(setIsLoading(isLoading));
  }, [
    userItemLoading,
    choiceLoading,
    achievementLoading,
    choiceResultLoading,
    reachedEndingLoading,
    propsLoading,
    chatLoading,
    userInputChoiceLoading,
    requestsTTSLoading,
    getTTSUrlLoading,
    syncUserItemLoading,
    remoteScriptLoading,
  ]);

  useEffect(() => {
    if (autoPlayType === 'play') {
      startAutoPlayReading({
        storyName: playChapterInfo?.playChapter.story.name,
        chapterIndex: playChapterInfo?.playChapter.chapterIndex,
      });
      onAutoPlay();
    } else {
      onFinishAutoPlay();
    }
  }, [autoPlayType]);

  useEffect(() => {
    if (remoteScriptData) {
      remoteStatementsRef.current = JSON.parse(
        remoteScriptData.getRemoteScriptStatements.statements,
      );
      onChatProgress();
    }
  }, [remoteScriptData]);

  useEffect(() => {
    remoteChatGPTStatement && onChatGPTPlay();
  }, [remoteChatGPTStatement]);

  useEffect(() => {
    if (!onChatGPTMode) {
      handleAutoPlay();
      onChatGPTTTSPlay();
      onChatProgress();
    }

    const intervalMoveToEnd = setInterval(() => {
      onChatGPTMode && moveToEnd();
    }, 1800);

    return () => {
      clearInterval(intervalMoveToEnd);
    };
  }, [onChatGPTMode]);

  useEffect(() => {
    choiceStatistics && setAutoPlayType('hidden');
  }, [choiceStatistics]);

  const onSendAchievementEvent = (statement: Statement) => {
    const eventInfo = {
      storyId: playChapterInfo?.playChapter.storyId,
      event: statement?.event,
    };
    useSendAchievementEvent({
      variables: eventInfo,
    });
  };

  const onChatGPTTTSPlay = () => {
    // TODO: TTS가 한 번에 재생될 때 수정될 로직
    const isPlay = sessionStorage.getItem(STORAGE_KEY.IS_CHATGPT_PLAY);
    if (!remoteChatGPTStatement || isPlay) return;

    const chatListSourceLine = chatList?.map(
      (statement) => statement.sourceLine,
    );
    const findSourceLine = remoteChatGPTStatement?.filter((statement) =>
      chatListSourceLine.includes(statement.sourceLine),
    );

    if (onChatGPTMode && remoteChatGPTStatement.length > 1) {
      onPlayTTSStatement(
        remoteChatGPTStatement[remoteChatGPTStatement.length - 2],
      );
    }

    if (
      !onChatGPTMode &&
      findSourceLine?.length === remoteChatGPTStatement?.length
    ) {
      onPlayTTSStatement(
        remoteChatGPTStatement[(remoteChatGPTStatement?.length ?? 1) - 1],
      );
    }
  };

  const onChatGPTPlay = () => {
    if (!remoteChatGPTStatement) return;

    const currentChatGPTStatement =
      remoteChatGPTStatement[(remoteChatGPTStatement?.length ?? 1) - 1];
    const findStatement = chatList.find(
      (statement) =>
        statement.sourceLine === currentChatGPTStatement?.sourceLine,
    );

    if (findStatement) {
      const result = chatList.map((statement) => {
        if (statement.sourceLine === currentChatGPTStatement?.sourceLine) {
          return {
            ...setStatementCustomText({
              statement: {
                ...statement,
                message: currentChatGPTStatement.message,
              },
              mainCharacterName: playChapterInfo?.mainCharacterName,
              otherCharacters: playChapterInfo?.playingOtherCharacters || [],
              props: propsRef.current!,
              items: itemsRef.current!,
            }),
            isShow: isShowStatement({
              ...statement,
              message: currentChatGPTStatement.message,
            }),
          };
        } else {
          return {
            ...setStatementCustomText({
              statement,
              mainCharacterName: playChapterInfo?.mainCharacterName,
              otherCharacters: playChapterInfo?.playingOtherCharacters || [],
              props: propsRef.current!,
              items: itemsRef.current!,
            }),
            isShow: isShowStatement(statement),
          };
        }
      });
      setChatList(result);
    } else {
      setChatList((prev) => [
        ...(prev ?? []),
        {
          ...setStatementCustomText({
            statement: currentChatGPTStatement,
            mainCharacterName: playChapterInfo?.mainCharacterName,
            otherCharacters: playChapterInfo?.playingOtherCharacters || [],
            props: propsRef.current!,
            items: itemsRef.current!,
          }),
          isShow: isShowStatement(currentChatGPTStatement),
        },
      ]);
      sessionStorage.removeItem(STORAGE_KEY.IS_CHATGPT_PLAY);
      onChatGPTTTSPlay();
      moveToEnd();
    }
  };

  const onFinishAutoPlay = () => {
    autoPlayRef.current && clearInterval(autoPlayRef.current);
  };

  const onAutoPlay = () => {
    autoPlayRef.current && clearInterval(autoPlayRef.current);
    const delay = 1500 / (fastRateRef.current ?? 1);
    autoPlayRef.current = setInterval(() => {
      onChatProgress();
    }, delay);
  };

  const loadChatData = () => {
    if (!playChapterInfo) return;

    const playInfo = playChapterInfo?.currentPlayInfo;
    const chapterInfo = playChapterInfo.playChapter;
    const endings = playChapterInfo.playedEndings;
    const chatBlocks = playChapterInfo.chatBlocks;
    const firstBlock = chatBlocks?.[0];
    if (
      playInfo?.chapterId !== chapterInfo?.chapterId ||
      !playInfo ||
      !playChapterInfo?.chatBlocks
    ) {
      chatBlockRef.current = firstBlock;
      setChatProgress({ index: 0, sourceLine: -1 });
      choiceRef.current = {
        choiceName: '',
        choiceIndex: 0,
        choiceUserInput: undefined,
      };
      const initItems =
        playChapterInfo.playChapter.chapterIndex === 1
          ? ''
          : playChapterInfo.playChapter.story.lastPlay?.playedChapters.find(
              (item) =>
                item.chapter?.chapterIndex ===
                playChapterInfo.playChapter.chapterIndex - 1,
            )?.currentItems;
      updateProps(
        chapterInfo?.story?.lastPlay?.currentPlayingChapter?.initProps,
      );
      updateItems(JSON.parse(initItems || '{}'));
      onChatProgress();
    } else {
      const selectedChoices = playChapterInfo.selectedChoices || [];
      const initItems =
        playChapterInfo.playChapter.chapterIndex === 1
          ? ''
          : playChapterInfo.playChapter.story.lastPlay?.playedChapters.find(
              (item) =>
                item.chapter?.chapterIndex ===
                playChapterInfo.playChapter.chapterIndex - 1,
            )?.currentItems;

      const {
        loadList,
        blockName,
        props,
        items,
        blockHistory,
        chatProgressInfo,
        fullScreenEffectInfo,
      } = onLoadStory({
        endings,
        selectedChoices,
        chatBlocks,
        mainCharacterName: playChapterInfo.mainCharacterName,
        otherCharacters: playChapterInfo.playingOtherCharacters,
        initProps:
          chapterInfo?.story?.lastPlay?.currentPlayingChapter?.initProps,
        initItems: JSON.parse(initItems || '{}'),
        playData: getPlayDataString(),
        currentPlayInfo: playInfo,
        lastPlay: playChapterInfo.playChapter.story.lastPlay,
      });
      setFullScreenEffectInfo(fullScreenEffectInfo || null);
      blockHistory && setBlockHistory({ chatBlocks: blockHistory });
      chatBlockRef.current = chatBlocks?.find(
        (block) => block.name === blockName,
      );

      setChatProgress({
        index: chatProgressInfo?.lastSourceIndex || 0,
        sourceLine: chatProgressInfo?.lastSourceLine ?? -1,
      });
      choiceRef.current = {
        choiceName: '',
        choiceIndex: 0,
        choiceUserInput: undefined,
      };
      props && updateProps(props);
      items && updateItems(items);
      setChatList(loadList);

      onChangeBlock(
        blockName,
        chatProgressInfo.lastSourceIndex < 0
          ? undefined
          : chatProgressInfo.lastSourceIndex + 1,
      );
      const lastIndex = (loadList?.length || 1) - 1;
      loadList?.[lastIndex] && setStatementBackground(loadList?.[lastIndex]);

      const saveProps = {
        storyId: playChapterInfo.playChapter.storyId,
        chapterId: playChapterInfo.playChapter.chapterId,
        updatedUserProps: JSON.stringify(propsRef.current),
      };
      onUserProps({
        variables: saveProps,
      });
      const saveItems = {
        storyId: playChapterInfo.playChapter.storyId,
        chapterId: playChapterInfo.playChapter.chapterId,
        updatedUserItems: JSON.stringify(itemsRef.current),
      };

      useSyncUserItem({
        variables: saveItems,
      });
    }
    moveToEnd();
  };

  const initChatData = () => {
    return new Promise((resolve, reject) => {
      setChatLoading(true);
      loadChatData();
      resolve(true);
    }).finally(() => {
      setChatLoading(false);
    });
  };

  const onChoiceResult = () => {
    if (autoPlayType === 'play') {
      onAutoPlay();
    } else {
      onChatProgress();
    }
  };

  // 프로필 이미지 적용
  const getProfile = (statement: Statement) => {
    if (
      statement?.statementType === 'MainCharacterTalk' ||
      statement?.statementType === 'MainCharacterThink' ||
      statement?.statementType === 'MainCharacterMessageImage'
    ) {
      return (
        playChapterInfo?.playChapter.story.lastPlay?.currentPlayingChapter
          ?.profileImageFile?.link ||
        playChapterInfo?.playChapter.story.mainCharacterImageFile?.link
      );
    } else if (
      statement?.statementType === 'CharacterTalk' ||
      statement?.statementType === 'CharacterThink' ||
      statement?.statementType === 'MessageImage'
    ) {
      const playingCharacterImage =
        playChapterInfo?.playChapter?.story?.lastPlay?.currentPlayingChapter?.playingCharacters?.find(
          (item) => item.character?.name === statement.chrName,
        );
      return (
        playingCharacterImage?.profileImageFile?.link ||
        playChapterInfo?.playChapter.story.characters.find(
          (item) => item.name === statement.chrName,
        )?.imageFile?.link
      );
    } else {
      return undefined;
    }
  };

  const setStatementBackground = (statement: StatementItem) => {
    const backgrounds = playChapterInfo?.playChapter.story.backgrounds;
    if (backgrounds && background?.name !== statement?.background) {
      const bg = backgrounds.find(
        (item) => item.name === statement?.background,
      );
      setBackground(bg);
    } // 배경이미지 변경
  };

  /**
   * Chat Progress function
   */
  const onUpdateItem = (statement: Statement) => {
    if (itemsRef.current && statement?.itemUpdate) {
      const { newMergeItems, updateItemCount, updateItemName } =
        getUpdatedItems({
          currentItems: itemsRef.current,
          newItems: statement?.itemUpdate,
          playData: getPlayDataString(),
        });
      if (updateItemName && updateItemCount) {
        const itemInfo = {
          storyId: playChapterInfo?.playChapter.storyId,
          chapterId: playChapterInfo?.playChapter.chapterId,
          updatedItem: updateItemName,
          updatedUserItems: JSON.stringify(newMergeItems),
        };
        updateItems(newMergeItems);
        itemOPCountRef.current = updateItemCount;
        useUpdateItem({
          variables: itemInfo,
        });
      } else {
        onChatProgress();
      }
    }
  };

  const onUpdateItemToast = (storyItem: StoryItem) => {
    const item: TopToast = {
      id: storyItem.storyItemId,
      name: storyItem.name,
      displayName: storyItem.displayName,
      type: 'item',
      description: storyItem.desc || '',
      imageLink: storyItem.imageFile?.link,
      itemCount: storyItem.itemCount,
    };
    setTopToasts((prev) => [...(prev || []), item]);
  };

  const onFinalEnding = async (
    statement: Statement,
    statements: Statement[],
    currentIndex: number,
  ) => {
    const finalEndingInfo = handleFinalEndings(statements, currentIndex);

    const customName = playChapterInfo
      ? setCustomNameToText({
          text:
            finalEndingInfo?.displayName || finalEndingInfo?.endingName || '',
          playChapterInfo: playChapterInfo,
        })
      : finalEndingInfo?.displayName || finalEndingInfo?.endingName;
    const customDesc = playChapterInfo
      ? setCustomNameToText({
          text: finalEndingInfo.endingDesc || '',
          playChapterInfo: playChapterInfo,
        })
      : finalEndingInfo?.endingDesc;
    const convertCustomDesc = convertPropsCountFormat({
      text: customDesc!,
      props: propsRef.current!,
    });

    const endingReq = {
      storyId: playChapterInfo?.playChapter.storyId,
      chapterId: playChapterInfo?.playChapter.chapterId,
      endingName: statement?.endingName,
      customEndingName: customName, // 엔딩의 커스텀 이름 (템플릿 형식일 경우, 적용한 이름)
      customEndingDescription: convertCustomDesc, //엔딩의 커스텀 설명 (템플릿 형식일 경우, 적용한 이름)
    };

    useReachedEnding({
      variables: endingReq,
    });
  };

  const onSaveProps = (statement: Statement) => {
    if (propsRef.current && statement.propUpdate) {
      const props = onMergeProps(
        propsRef.current,
        statement.propUpdate,
        getPlayDataString(),
      );
      const saveProp = {
        storyId: playChapterInfo?.playChapter.storyId,
        chapterId: playChapterInfo?.playChapter.chapterId,
        updatedUserProps: JSON.stringify(props),
      };
      updateProps(props);
      onUserProps({
        variables: saveProp,
      });
    }
    onChatProgress();
  };

  const onEndingSummary = async (statement: Statement) => {
    const endingInfo = {
      storyId: playChapterInfo?.playChapter.storyId,
      chapterId: playChapterInfo?.playChapter.chapterId,
      endingName: statement?.endingName,
      customEndingName: convertCharName(
        statement?.displayName || statement?.endingName || '',
        playChapterInfo?.mainCharacterName.firstName || '',
        playChapterInfo?.mainCharacterName?.lastName || '',
      ), // 엔딩의 커스텀 이름 (템플릿 형식일 경우, 적용한 이름)
      customEndingDescription: null, //엔딩의 커스텀 설명 (템플릿 형식일 경우, 적용한 이름)
    };

    useReachedEnding({
      variables: endingInfo,
    });
  };

  const onCondition = (statement: Statement) => {
    if (propsRef.current && itemsRef.current) {
      const { isChange, newBlockName } = handleCondition({
        condition: statement,
        endings: playChapterInfo?.playedEndings || [],
        currentProps: propsRef.current,
        currentItems: itemsRef.current,
        playData: getPlayDataString(),
      });
      if (isChange) {
        onChangeBlock(newBlockName || statement?.block);
      } else {
        onChatProgress();
      }
    }
  };

  const addChoiceStatistics = (choiceId: number) => {
    if (playChapterInfo) {
      const lastItem = chatList[chatList.length - 1];
      const choiceItem = getChoiceRateItem({
        choiceId: choiceId,
        storyId: playChapterInfo?.playChapter.storyId,
        chapterId: playChapterInfo?.playChapter.chapterId,
        background: lastItem.background,
      });
      setChatList((prev) => [...(prev || []), choiceItem]);
      moveToEnd();
    } else {
      onChatProgress();
    }
  };

  const onChatProgress = (pressType?: 'click' | 'item' | 'achievement') => {
    if (onChatGPTMode) return;
    if (isPause) return;
    const statements = chatBlockRef.current?.statements;

    if (
      !statements ||
      endingPopupInfo ||
      chatProgressRef?.current.index >= statements.length ||
      (pressType !== 'achievement' && badgesAcquired) ||
      (pressType !== 'item' && storyItems)
    ) {
      return;
    }

    if (
      pressType === 'click' &&
      (choice ||
        endingPopupInfo ||
        storyItems ||
        badgesAcquired ||
        choiceStatistics)
    ) {
      return;
    }

    const currentIndex = remoteStatementsRef.current
      ? 0
      : chatProgressRef.current.index!;
    const statement = remoteStatementsRef.current
      ? remoteStatementsRef.current[currentIndex]
      : statements[currentIndex];
    const statementType = statement?.statementType;

    const statementItem: StatementItem = {
      ...setStatementCustomText({
        statement,
        mainCharacterName: playChapterInfo?.mainCharacterName,
        otherCharacters: playChapterInfo?.playingOtherCharacters || [],
        props: propsRef.current!,
        items: itemsRef.current!,
      }),
      isShow: isShowStatement(statement),
    };

    if (remoteStatementsRef.current) {
      remoteStatementsRef.current.shift();
      if (remoteStatementsRef.current?.length < 1) {
        remoteStatementsRef.current = undefined;
      }
    } else {
      setChatProgress({
        index: chatProgressRef.current.index + 1,
        sourceLine: statementItem.sourceLine,
      });
    }

    if (
      onExecuteCondition({
        statement,
        playData: getPlayDataString(),
      })
    ) {
      if (
        statement.statementType === 'FullWidthImage' &&
        statement.fullScreenOptions
      ) {
        setAutoPlayType('hidden');
        addFullScreenPopupInfo(statementItem);
        return;
      }

      setChatList((prev) => [...(prev || []), statementItem]);
    } else {
      onChatProgress();
      return;
    }

    if (playChapterInfo?.isFloatingADStory) {
      floatingADCountRef.current++;
      if (floatingADCountRef.current > FLOATING_COUNT) {
        setIsShowFloatingAD(true);
      }
    }

    switch (statementType) {
      case 'Choice':
        // 채팅 선택 모드 변경, 선택 진행
        setAutoPlayMode(autoPlayType === 'play' ? true : false);
        onFinishAutoPlay();
        setChoice(statement);
        // ChoiceInputImage
        moveToEnd();
        break;
      case 'ChoiceToBlock':
        // 선택 완료 후 block 이동
        onChoiceMoveToBlock(statementItem);
        break;
      case 'ToBlock':
        // 다음 블럭으로 이동
        onChangeBlock(statement?.block);
        break;
      case 'Condition':
        // 현재 Condition은 MoveToBlock 타입만 있음.
        onCondition(statement);
        break;
      case 'MoveToBlock':
        onCondition(statement);
        break;
      case 'EndingSummary':
        // 엔딩정보를 만나면 reachedEnding 호출
        setAutoPlayType('hidden');
        onEndingSummary(statement);
        break;
      case 'SaveProp':
        // props 저장
        handleAutoPlay();
        onSaveProps(statement);
        break;
      case 'FinalEnding':
        setAutoPlayType('hidden');
        onFinalEnding(statement, statements, currentIndex);
        // 최종엔딩 처리
        break;
      case 'AchievementEvent':
        // 업적획득
        setAutoPlayType('hidden');
        onSendAchievementEvent(statement);
        break;
      case 'UpdateItem':
        // 아이템 정보 업데이트
        setAutoPlayType('hidden');
        onUpdateItem(statement);
        break;
      case 'BGMon':
        // BGM 재생
        statement?.link &&
          setChatSoundBGM({
            audioLink: statement?.link,
            type: 'BGM',
          });
        onChatProgress();
        break;
      case 'BGMoff':
        // BGM 종료
        setChatSoundBGM({
          audioLink: '',
          type: 'BGM',
        });
        onChatProgress();
        break;
      case 'SoundEffect':
        //소리 재생 후 다음 스크립트 진행
        statement?.link &&
          setChatSoundEffect({
            audioLink: statement?.link,
            type: 'SoundEffect',
          });
        onChatProgress();
        break;
      case 'Vibration':
        // TODO 추후 진동 지원 여부 검토
        // 아이폰 지원 불가
        // 다음 스크립트 진행
        onChatProgress();
        break;
      case 'Toast':
        // 토스트 메시지 표시
        setToastList((prev) => [...prev, statementItem]);
        break;
      case 'ChoiceIfUpdateItem':
      case 'ChoiceIfAchievementEvent':
      case 'ChoiceIfSaveProp':
      case 'ChoiceSaveProp':
        addChoiceInfo(statementItem);
        break;
      case 'TTSCashing':
        // tts 사전 캐싱
        onRequestsTTS(statementItem);
        break;
      case 'CallRemoteScript':
        if (statement?.remoteScriptType === 'ChatGPT') {
          setCurrentStatement(statementItem);
          onRemoteScriptChatGPT(statementItem);
        } else {
          onRemoteScript(statementItem);
        }
        break;
      case 'FinishRemoteScript':
        sessionStorage.removeItem(STORAGE_KEY.IS_CHATGPT_PLAY);
        setAutoPlayMode(false);
        retryCountRef.current = 1;
        setOnChatGPTMode(false);
        setRemoteChatGPTStatement(undefined);
        onChangeBlock(statement?.toBlockAfter);
        break;
      case 'FullScreenEffectOn':
      case 'FullScreenEffectOff':
        setFullScreenEffectInfo(statementItem);
        break;
      case 'Pause':
        setIsPause(true);
        setTimeout(() => {
          setIsPause(false);
          onChatProgress();
        }, statementItem.timeout);
        break;
      case 'MainCharacterTalk':
      case 'MainCharacterThink':
      case 'CharacterThink':
      case 'CharacterTalk':
        onPlayTTSStatement(statementItem);
        setStatementBackground(statementItem);
        moveToEnd();
        break;
      default:
        setStatementBackground(statementItem);
        moveToEnd();
        break;
    }
  };

  const addFullScreenPopupInfo = (statement: StatementItem) => {
    if (!statement.fullScreenOptions) return;

    const imageInfo = statement.fullScreenOptions.fullScreenImageLink
      ? statement.fullScreenOptions
      : {
          ...statement.fullScreenOptions,
          fullScreenImageLink: statement.link,
          width: statement.width,
          height: statement.height,
        };

    setFullScreenImagePopupInfo(imageInfo);

    if (statement.fullScreenOptions?.showTransition === 'None') {
      const img = new Image();
      img.src = imageInfo.fullScreenImageLink || '';
      img.onload = () => {
        setChatList((prev) => [...(prev || []), statement]);
        setStatementBackground(statement);
        moveToEnd();
      };
    } else {
      setTimeout(() => {
        const img = new Image();
        img.src = imageInfo.fullScreenImageLink || '';
        img.onload = () => {
          setChatList((prev) => [...(prev || []), statement]);
          setStatementBackground(statement);
          moveToEnd();
        };
      }, imageInfo.duration || 0);
    }
  };

  const onPlayTTSStatement = (statement: Statement) => {
    const textOptions: TextOptions = statement.textOptions;
    if (textOptions && isTTSOnRef.current) {
      isTTSOnRef.current && setAutoPlayType('hidden');
      const accessToken = cashingTTSListRef.current.find(
        (item) =>
          item.text === statement.message &&
          item.speakerId === textOptions.speakerId,
      )?.accessToken;
      const reqTTS: TTSCashingData = {
        text: statement.message,
        emotion: textOptions.emotion,
        speakerId: textOptions.speakerId,
        dpeId: textOptions.dpeId,
        accessToken,
      };
      useGetTTSUrl({ variables: reqTTS });
    }
  };

  const onRequestsTTS = (statement: Statement) => {
    const textOptions: TextOptions = statement.textOptions;
    if (textOptions) {
      const reqTTS: TTSCashingData = {
        text: statement.message,
        emotion: textOptions.emotion,
        speakerId: textOptions.speakerId,
        dpeId: textOptions.dpeId,
      };
      cashingTTSRef.current = reqTTS;
      useRequestsTTS({ variables: reqTTS });
    }
  };

  const onCallMakeChoice = () => {
    if (playChapterInfo) {
      const choiceInfo: MakeChoiceData = getMakeChoiceInfo({
        playChapterInfo,
        props: propsRef.current!,
        items: itemsRef.current!,
        choiceIfInfos: choiceOptionsRef.current,
        choice: {
          choiceName: choiceRef.current.choiceName,
          choiceIndex: choiceRef.current.choiceIndex,
          showStatistics: choice?.options?.showStatistics ?? false,
        },
        playData: getPlayDataString(),
      });

      choiceToInfoRef.current = choiceInfo.updatedUserItems;
      choiceInfo.updatedUserProps &&
        updateProps(JSON.parse(choiceInfo.updatedUserProps));
      choiceInfo.updatedUserItems && updateItems(choiceInfo.updatedUserItems);

      onMakeChoice({
        choiceInfo,
        isClearChoice: true,
      });

      handleAutoPlay();
    }
  };

  const handleAutoPlay = () => {
    setAutoPlayType(autoPlayMode ? 'play' : 'hidden');
  };

  const addChoiceInfo = (statement: Statement) => {
    choiceOptionsRef.current.push(statement);
    const statements = chatBlockRef.current?.statements;
    if (statements) {
      const nextStatement = statements[chatProgressRef.current.index];
      if (
        nextStatement.statementType === 'ChoiceIfUpdateItem' ||
        nextStatement.statementType === 'ChoiceIfAchievementEvent' ||
        nextStatement.statementType === 'ChoiceIfSaveProp' ||
        nextStatement.statementType === 'ChoiceSaveProp'
      ) {
        onChatProgress();
      } else {
        onCallMakeChoice();
      }
    }
  };

  const onChangeBlock = (blockName?: string, progressIndex?: number) => {
    if (!blockName) return;

    const block = playChapterInfo?.chatBlocks.find(
      (item) => item.name === (blockName || chatBlockRef.current?.name),
    );

    if (block) {
      setBlockHistory({ addBlock: block });
      // 블럭 변경이 발생하면 progressIndex를 초기화 한다.
      setChatProgress({
        index: progressIndex === undefined ? 0 : progressIndex,
        sourceLine: chatProgressRef.current.sourceLine,
      });
      chatBlockRef.current = block;
      if (progressIndex === undefined || progressIndex < 0) {
        onChatProgress();
      }
    }
  };

  const onChoice = ({
    choiceName,
    choiceItem,
    choiceUserInput,
  }: {
    choiceName: string;
    choiceItem?: {
      choiceIndex: number;
      selectedName: string;
    };
    choiceUserInput?: {
      leftUserInputText?: string;
      rightUserInputText?: string;
    };
  }) => {
    const statements = chatBlockRef.current?.statements;
    if (statements) {
      choiceRef.current.choiceName = choiceName;
      if (choiceItem) {
        choiceRef.current.choiceIndex = choiceItem.choiceIndex;
        makeChoice({
          storyName: playChapterInfo?.playChapter.story.name,
          chapterIndex: playChapterInfo?.playChapter.chapterIndex,
          choiceName: choiceItem.selectedName,
        });

        const nextStatement = statements[chatProgressRef.current.index];
        if (nextStatement.statementType === 'ChoiceToBlock') {
          onCallMakeChoice();
        } else {
          onChatProgress();
        }
      } else if (choiceUserInput) {
        onChoiceUserInput({
          choiceName,
          choiceUserInput,
          statements,
        });
      } else {
        onChatProgress();
      }
    }
  };

  const onChoiceUserInput = ({
    choiceName,
    choiceUserInput,
    statements,
  }: {
    choiceName: string;
    choiceUserInput: {
      leftUserInputText?: string;
      rightUserInputText?: string;
    };
    statements: Statement[];
  }) => {
    const nextStatement = statements[chatProgressRef.current.index];
    if (nextStatement.statementType === 'ChoiceSaveProp') {
      const { props, newIndex } = getChoiceSaveProps(
        propsRef.current,
        statements,
        chatProgressRef.current.index - 1 || 0,
        choiceRef.current.choiceIndex,
      );
      chatProgressRef.current.index = newIndex;
      updateProps(props);
    }
    const userInputChoice = {
      chapterId: playChapterInfo?.playChapter.chapterId,
      choiceName: choiceName,
      leftUserInputText: choiceUserInput.leftUserInputText,
      rightUserInputText: choiceUserInput.rightUserInputText,
    };
    choiceRef.current.choiceUserInput = {
      leftUserInputText: choiceUserInput.leftUserInputText,
      rightUserInputText: choiceUserInput.rightUserInputText,
    };
    useGetUserInputChoice({ variables: userInputChoice });
  };

  const onSavePlay = () => {
    sessionStorage.setItem(STORAGE_KEY.IS_CHATGPT_PLAY, 'true');
    onFinishAutoPlay();

    const progressIndex =
      chatProgressRef?.current?.index ??
      playChapterInfo?.currentPlayInfo?.lastSourceIndex;

    const sourceLine =
      chatProgressRef?.current?.sourceLine ??
      playChapterInfo?.currentPlayInfo?.lastSourceLine;

    playChapterInfo &&
      onSavePlayData(playChapterInfo, {
        blockName: chatBlockRef?.current?.name || '',
        progressIndex: progressIndex ?? -1,
        choiceIndex: 0,
        sourceLine: sourceLine ?? -1,
      });
  };

  const moveToEnd = (msec?: number) => {
    setTimeout(() => {
      scrollRef.current?.scrollTo({
        behavior: 'auto',
        left: 0,
        top: scrollRef.current?.scrollHeight,
      });
    }, msec || 100);
  };

  const onAutoPlayRate = (rate: number) => {
    autoPlayRef.current && clearInterval(autoPlayRef.current);
    fastRateRef.current = rate;
    setAutoPlayType('play');
    onAutoPlay();
  };

  const onConfirmPopup = (type: 'item' | 'achievement' | 'ending') => {
    if (type === 'item') {
      setStoryItems(undefined);
      onChatProgress('item');
    } else if (type === 'achievement') {
      setBadgesAcquired(undefined);
      onChatProgress('achievement');
    } else if (type === 'ending') {
      setEndingPopupInfo((prev) => {
        return prev
          ? {
              ...prev,
              isShow: false,
            }
          : prev;
      });
    }
  };

  const oncloseChoiceStatistics = () => {
    setChoiceStatistics(undefined);
    autoPlayType === 'play' && onAutoPlay();
  };

  const onGetChoiceResult = (info?: {
    storyId: number;
    chapterId: number;
    choiceId: number;
  }) => {
    if (
      getChoiceResult?.getUserChoiceResult?.choiceResult?.choiceId ===
      info?.choiceId
    ) {
      const getUserChoiceResult = getChoiceResult?.getUserChoiceResult;
      if (getUserChoiceResult?.choiceResult) {
        handleChoiceStatistics({
          choiceResult: getUserChoiceResult?.choiceResult,
          selectedIndex:
            getUserChoiceResult?.userSelectedChoice?.selectedChoice ?? 1,
          isReplay: true,
        });
      }
    } else {
      getChoiceResultMutation({
        variables: info,
      });
    }
  };

  const onShowCharacterProfile = (characterProfile?: {
    title: string;
    imageUrl?: string;
  }) => {
    setCharacterProfile(
      characterProfile
        ? {
            title: characterProfile?.title,
            imageUrl: characterProfile?.imageUrl,
          }
        : undefined,
    );
  };

  const onMakeChoice = ({
    choiceInfo,
    isClearChoice = true,
  }: {
    choiceInfo: MakeChoiceData;
    isClearChoice?: boolean;
  }) => {
    isClearChoice && setChoice(undefined);
    onMakeChoiceMergeProps(choiceInfo);
    useMakeChoice({
      variables: choiceInfo,
    });
  };

  const addChoiceInputItem = () => {
    if (
      choice &&
      playChapterInfo &&
      choice?.options?.layoutType === 'UserInputChoice'
    ) {
      if (playChapterInfo) {
        const choiceItem: StatementItem | undefined = getUserInputChoiceItem({
          sourceLine: choice?.sourceLine,
          background: choice?.background,
          choiceOptions: choice?.options,
          storyId: playChapterInfo?.playChapter.storyId,
          chapterId: playChapterInfo?.playChapter.chapterId,
          mainCharacterName: playChapterInfo?.mainCharacterName,
          rightUserInputText:
            choiceRef.current.choiceUserInput?.rightUserInputText,
        });
        setChoice(undefined);
        if (choiceItem) {
          setChatList((prev) => [...(prev || []), choiceItem]);
          moveToEnd();
        }
      } else {
        onChatProgress();
      }
    }
  };

  const handleChoiceStatistics = (getUserChoiceResult: {
    choiceResult: ChoiceResult;
    selectedIndex: number;
    isReplay: boolean;
  }) => {
    const choiceItem = chatList.find(
      (item) =>
        item?.choiceId === getUserChoiceResult?.choiceResult?.choiceId &&
        item.statementType === 'ChoiceRate',
    );
    if (!choiceItem && getUserChoiceResult?.choiceResult?.choiceId) {
      addChoiceStatistics(getUserChoiceResult?.choiceResult?.choiceId);
    }

    setChoiceStatistics({
      choiceResult: getUserChoiceResult?.choiceResult,
      selectedIndex: getUserChoiceResult.selectedIndex,
      isReplay: getUserChoiceResult.isReplay,
    });
  };

  const onChoiceMoveToBlock = (statement: Statement) => {
    setChoice(undefined);
    onChangeBlock(statement?.choices?.[choiceRef.current.choiceIndex]);
    choiceRef.current = {
      choiceName: '',
      choiceIndex: 0,
      choiceUserInput: undefined,
    };
  };

  const onMakeChoiceMergeProps = (choiceInfo: MakeChoiceData) => {
    const currentProps = propsRef.current;
    if (currentProps) {
      const newProps = mergeChoiceToProps({
        props: currentProps,
        choiceName: choiceInfo.choiceName,
        rightUserInputText: choiceInfo.rightUserInputText,
        choiceNumber: choiceInfo.choice,
      });
      updateProps(newProps);
    }
  };

  const onRemoteScript = (statement: Statement) => {
    const params = statement.params.map((item) => {
      return chatCalculate(item, getPlayDataString());
    });

    const result = {
      provider: statement.provider,
      remoteScriptType: statement.remoteScriptType,
      chapterId: playChapterInfo?.playChapter.chapterId,
      remoteScriptId: statement.scriptId,
      params,
      background: statement.background,
    };
    useGetRemoteScript({ variables: result });
  };

  const fetchSSE = ({
    prompt,
    sourceLine,
    chapterId,
    remoteScriptId,
    scriptForm,
  }: {
    prompt: string;
    sourceLine: number;
    chapterId?: number;
    remoteScriptId: string;
    scriptForm?: string;
  }) => {
    if (retryCountRef.current > 2) {
      setOnChatGPTMode(false);
      setIsShowRetryChatGPTPopup(false);
      dispatchRTK(setIsLoading(false));
      return;
    }

    const properties = localStorage.getItem(STORAGE_KEY.USER_PROPERTIES);
    const { user_id } = properties && JSON.parse(properties);
    const authToken = localStorage.getItem(STORAGE_KEY.AUTH_TOKEN);

    fetch(`${getChatGptURL()}/chatGPT/sse`, {
      method: 'POST',
      headers: {
        token: authToken!,
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify({
        prompt,
        sourceLine,
        chapterId,
        remoteScriptId,
        scriptForm,
        userId: user_id,
        retryCount: retryCountRef.current,
      }),
    })
      .then((response) => {
        retryCountRef.current += 1;
        dispatchRTK(setIsLoading(false));

        if (!response.ok) {
          setIsShowRetryChatGPTPopup(true);
          setOnChatGPTMode(false);
          Sentry.captureException(`SSE Error: ${response.statusText}`);
          return;
        }

        const reader = response.body!.getReader();
        const decoder = new TextDecoder();

        const readChunk = () => {
          return reader.read().then(appendChunks);
        };

        const appendChunks = (result: any): any => {
          const chunk = decoder.decode(result.value || new Uint8Array(), {
            stream: !result.done,
          });
          const data = chunk.split('\n\n')[0].replaceAll('data: ', '');
          const parseData = JSON.parse(data);
          setRemoteChatGPTStatement(parseData);

          if (!result.done) {
            return readChunk();
          }
        };

        return readChunk();
      })
      .then((res) => {
        setOnChatGPTMode(false);
        dispatchRTK(setIsLoading(false));
      })
      .catch((e) => {
        if (e.message.includes('Fail')) {
          setIsShowRetryChatGPTPopup(true);
        }

        setOnChatGPTMode(false);
        dispatchRTK(setIsLoading(false));
        useGetCurrentProps({
          variables: {
            storyId: +(playChapterInfo?.playChapter.storyId ?? 0),
          },
        });
      });
  };

  const onRemoteScriptChatGPT = (statement: Statement) => {
    dispatchRTK(setIsLoading(true));
    setOnChatGPTMode(true);
    setAutoPlayMode(autoPlayType === 'play' ? true : false);
    setAutoPlayType('hidden');

    const convertPromptCharName = onReplacePostPosition(
      convertCharName(
        statement?.prompt ?? '',
        playChapterInfo?.mainCharacterName.firstName ?? '',
        playChapterInfo?.mainCharacterName?.lastName ?? '',
      ),
    );

    const convertPrompt = convertPropsCountFormat({
      text: convertPromptCharName,
      props: propsRef.current!,
    });

    fetchSSE({
      prompt: convertPrompt,
      sourceLine: statement?.sourceLine,
      chapterId: playChapterInfo?.playChapter.chapterId,
      remoteScriptId: statement?.scriptId,
      scriptForm: statement?.scriptForm,
    });
  };

  const onCloseFloatingAD = () => {
    floatingADCountRef.current = 0;
    setIsShowFloatingAD(false);
  };

  return (
    <ChatStoryContext.Provider
      value={{
        chatList,
        choice,
        background,
        toastList,
        badgesAcquired,
        storyItems,
        endingPopupInfo,
        autoPlayType,
        chatBlockRef,
        scrollRef,
        fastRateRef,
        choiceStatistics,
        characterProfile,
        topToasts,
        chatSoundEffect,
        chatBGM,
        chatTTS,
        isTTSOnRef,
        isShowFloatingAD,
        isShowRetryChatGPTPopup,
        currentStatement,
        onChatGPTMode,
        setAutoPlayType,
        getProfile,
        onFinishAutoPlay,
        onChatProgress,
        onChoice,
        onSavePlay,
        setToastList,
        onAutoPlayRate,
        onConfirmPopup,
        resetEnding,
        initChatData,
        oncloseChoiceStatistics,
        onGetChoiceResult,
        onShowCharacterProfile,
        onPlayTTSStatement,
        setTopToasts,
        onCloseFloatingAD,
        onRemoteScriptChatGPT,
        setIsShowRetryChatGPTPopup,
        fullScreenEffectInfo,
        fullScreenImagePopupInfo,
        setFullScreenImagePopupInfo,
      }}
    >
      {children}
    </ChatStoryContext.Provider>
  );
};

const useChatPlayContext = () => {
  const state = useContext(ChatStoryContext);
  if (!state) throw new Error('ChatStoryContext is undefined!');
  return state;
};

export { useChatPlayContext };

export default ChatPlayProvider;
